/* eslint-disable no-unused-expressions */

export const disableNextButton = (shouldDisableNext) => {
  if (shouldDisableNext) {
    document.querySelector("[name='next']")?.classList.add("button-disabled");
  } else {
    document.querySelector("[name='next']")?.classList.remove("button-disabled");
  }
}